import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
interface LegalShellProps {
  title: string;
  children: React.ReactNode;
}
export function LegalShell({
  title,
  children
}: LegalShellProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-cosmic-black text-white pt-24 pb-20 px-5 md:px-6" data-id="element-489">
      <div className="max-w-2xl mx-auto" data-id="element-490">
        <Link to="/" className="inline-block mb-10 text-gold-light/60 hover:text-gold-light transition-colors text-xs tracking-[0.2em] uppercase font-serif" data-id="element-491">
          ← Volver al inicio
        </Link>

        <h1 className="text-3xl md:text-4xl font-serif font-bold text-white mb-10 tracking-wide" data-id="element-492">
          {title}
        </h1>

        <div className="space-y-5 text-base md:text-lg font-serif text-white/75 leading-relaxed" data-id="element-493">
          {children}
        </div>
      </div>
    </div>;
}